module.exports = __webpack_public_path__ + "static/media/doorbell.5b269530.mp3";